import { io, Socket } from 'socket.io-client';
import { API_BASE } from './api';

let socket: Socket | null = null;

function readToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('bura_crm_token');
}

export function connectCrmSocket(): Socket {
  if (socket?.connected) return socket;
  const token = readToken();
  socket = io(`${API_BASE}/crm`, {
    transports: ['websocket', 'polling'],
    auth: { token },
    forceNew: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 8000
  });
  return socket;
}

export function getCrmSocket(): Socket | null {
  return socket;
}

export function disconnectCrmSocket() {
  socket?.disconnect();
  socket = null;
}
